export enum RvdStatuses {
  NOT_LOADED_CPRODUCT = 'Не выгружено в 1С',
  LOADED_CPRODUCT = 'Ожидает подтверждения',
  LOADING_ERROR = 'Ошибка выгрузки',
  PROCESS = 'В обработке в 1С',
  APPROVED = 'Проведен в 1С',
  CANCELED = 'Помечен на удаление или отменен в 1С',
}

export enum RvdStatusesBack {
  /**не загружен в 1с */
  NOT_LOADED_CPRODUCT = 'not_loaded',
  /** загружен в 1с и ждет подтверждения  */
  LOADED_CPRODUCT = 'loaded',
  /**в обработке в 1с */
  PROCESS = 'process',
  /** есть ошибка */
  ERROR = 'error',
  /** проведен в 1с */
  APPROVED = 'approved',
  /** помечен на удаление или отменен в 1с */
  CANCELED = 'canceled',
}

export const RVDS_BADGES: Record<RvdStatusesBack, 'error' | 'default' | 'success' | 'processing' | 'warning'> = {
  [RvdStatusesBack.NOT_LOADED_CPRODUCT]: 'warning',
  [RvdStatusesBack.LOADED_CPRODUCT]: 'success',
  [RvdStatusesBack.PROCESS]: 'default',
  [RvdStatusesBack.ERROR]: 'error',
  [RvdStatusesBack.APPROVED]: 'processing',
  [RvdStatusesBack.CANCELED]: 'error',
};

export enum RvdCompensationType {
  HOLIDAY = 'Отгул',
  MONEY = 'Повышенная оплата',
}

export enum ExcelRvdCompensationType {
  HOLIDAY = 'одинарная оплата + день отдыха',
  MONEY = 'двойная оплата',
}

export enum RvdBack {
  HOLIDAY = 'holiday',
  MONEY = 'money',
}

export const RvdStatusToBack: Record<RvdStatuses, RvdStatusesBack> = {
  [RvdStatuses.LOADED_CPRODUCT]: RvdStatusesBack.LOADED_CPRODUCT,
  [RvdStatuses.NOT_LOADED_CPRODUCT]: RvdStatusesBack.NOT_LOADED_CPRODUCT,
  [RvdStatuses.LOADING_ERROR]: RvdStatusesBack.ERROR,
  [RvdStatuses.PROCESS]: RvdStatusesBack.PROCESS,
  [RvdStatuses.APPROVED]: RvdStatusesBack.APPROVED,
  [RvdStatuses.CANCELED]: RvdStatusesBack.CANCELED,
};

export const RvdCompensationTypeToBack = {
  [RvdCompensationType.HOLIDAY]: 'holiday',
  [RvdCompensationType.MONEY]: 'money',
};

export const ExcelRvdCompensationTypeToFront = {
  [ExcelRvdCompensationType.HOLIDAY]: RvdCompensationType.HOLIDAY,
  [ExcelRvdCompensationType.MONEY]: RvdCompensationType.MONEY,
};

export const ExcelRvdCompensationTypeToBack = {
  [ExcelRvdCompensationType.HOLIDAY]: 'holiday',
  [ExcelRvdCompensationType.MONEY]: 'money',
};

export const ExcelRvdCompensationTypeFromBack = {
  [ExcelRvdCompensationType.HOLIDAY]: 'holiday',
  [ExcelRvdCompensationType.MONEY]: 'money',
};

export const RvdCompensationTypeFromBack = {
  holiday: RvdCompensationType.HOLIDAY,
  money: RvdCompensationType.MONEY,
};

export const RvdExcellCompensationTypeFromBack = {
  holiday: ExcelRvdCompensationType.HOLIDAY,
  money: ExcelRvdCompensationType.MONEY,
};

export const RvdStatusFromBack: Record<RvdStatusesBack, RvdStatuses> = {
  [RvdStatusesBack.LOADED_CPRODUCT]: RvdStatuses.LOADED_CPRODUCT,
  [RvdStatusesBack.NOT_LOADED_CPRODUCT]: RvdStatuses.NOT_LOADED_CPRODUCT,
  [RvdStatusesBack.PROCESS]: RvdStatuses.PROCESS,
  [RvdStatusesBack.ERROR]: RvdStatuses.LOADING_ERROR,
  [RvdStatusesBack.APPROVED]: RvdStatuses.APPROVED,
  [RvdStatusesBack.CANCELED]: RvdStatuses.CANCELED,
};
